const carousels = [
  {
    title: '暑期追漫季',
    desc: '热门连载一网打尽，暑假追漫不剧荒。精选50+部高分作品，韩漫日漫国漫全品类覆盖。',
    tag: '热门活动',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20vibrant%20summer%20themed%20illustration%20of%20colorful%20manga%20books%20and%20comic%20panels%20floating%20around%20a%20beach%20scene%20with%20palm%20trees%20and%20ocean%20waves%2C%20bright%20and%20energetic%20atmosphere%2C%20warm%20sunny%20color%20palette%20with%20coral%20and%20aqua%20accents%2C%20playful%20and%20fun%20vibe%2C%20clean%20minimal%20composition%2C%20modern%20flat%20design%20illustration%20style%2C%20perfect%20for%20a%20manga%20platform%20promotional%20banner&width=900&height=506&seq=carousel-01&orientation=landscape',
  },
  {
    title: '韩漫精选合集',
    desc: '高分韩漫一册打尽，从热门连载到经典完结。精致画风，独特叙事，发现你的下一部心头好。',
    tag: '专题推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20elegant%20illustration%20of%20beautifully%20styled%20Korean%20webtoon%20panels%20arranged%20in%20a%20collage%20with%20soft%20pastel%20color%20gradients%2C%20featuring%20romantic%20and%20dramatic%20scenes%2C%20delicate%20lineart%20and%20refined%20aesthetics%2C%20clean%20minimal%20composition%20with%20gentle%20lighting%2C%20modern%20digital%20illustration%20style%20inspired%20by%20Korean%20webtoon%20art%2C%20perfect%20for%20a%20comic%20platform%20showcase%20banner&width=900&height=506&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫崛起计划',
    desc: '不可错过的国产漫画佳作合集。从玄幻修仙到都市日常，见证国漫的无限可能。',
    tag: '专题推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20grand%20illustration%20showcasing%20the%20diversity%20of%20Chinese%20manhua%20featuring%20epic%20xianxia%20cultivation%20scenes%20and%20modern%20urban%20slice%20of%20life%20moments%20blended%20together%2C%20rich%20vermilion%20and%20gold%20color%20palette%20with%20traditional%20Chinese%20aesthetic%20elements%2C%20dynamic%20and%20inspiring%20atmosphere%2C%20clean%20minimal%20composition%2C%20modern%20Chinese%20manhua%20art%20style%2C%20perfect%20for%20a%20comic%20platform%20promotional%20banner&width=900&height=506&seq=carousel-03&orientation=landscape',
  },
  {
    title: '日漫经典重温',
    desc: '那些年追过的神作，经典日漫全收录。热血、治愈、悬疑，重温最初的感动。',
    tag: '经典回顾',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20illustration%20of%20classic%20Japanese%20manga%20elements%20including%20iconic%20action%20poses%20and%20emotional%20character%20moments%20rendered%20in%20warm%20sepia%20and%20vintage%20tones%2C%20surrounded%20by%20floating%20manga%20pages%20and%20speech%20bubbles%2C%20retro%20yet%20modern%20aesthetic%2C%20clean%20minimal%20composition%2C%20artistic%20digital%20illustration%20style%20with%20nostalgic%20vibe%2C%20perfect%20for%20a%20comic%20platform%20theme%20banner&width=900&height=506&seq=carousel-04&orientation=landscape',
  },
  {
    title: '新番速递站',
    desc: '本月最新上架作品一览，第一时间掌握新番动态。抢先追更，不错过任何一部潜力新作。',
    tag: '新番推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20fresh%20and%20exciting%20illustration%20of%20brand%20new%20manga%20covers%20emerging%20from%20a%20glowing%20portal%20with%20sparkles%20and%20magical%20effects%2C%20representing%20new%20releases%20and%20fresh%20content%2C%20bright%20and%20hopeful%20color%20palette%20with%20neon%20accents%2C%20energetic%20and%20anticipating%20atmosphere%2C%20clean%20minimal%20composition%2C%20modern%20digital%20illustration%20style%2C%20perfect%20for%20a%20comic%20platform%20new%20releases%20banner&width=900&height=506&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            妖精动漫精心策划的专题合集，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carousels.map((item, i) => (
            <a
              key={i}
              href={`#carousel`}
              onClick={(e) => e.preventDefault()}
              className={`group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-accent-200 transition-all duration-200 ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              } ${i === 3 ? 'sm:col-span-2 lg:col-span-2' : ''}`}
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.imageUrl}
                  alt={`妖精动漫 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50">
                  {item.tag}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-semibold text-white mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-white/80 line-clamp-2">{item.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}